import React, { Component } from 'react'

import gsap from 'gsap'
import { throttle } from 'lodash';

import { getViewportSize } from '../utils/screen'
import { getGlobalMask, setIntroRevealCallback } from './App'

import './AnimatedWrapper.css'

// Track if intro has been shown globally (persists across component instances)
let globalIntroShown = false;

class AnimatedWrapper extends Component {

        constructor(props) {

                super(props)

                this.state = {
                        wrapperDisplay: 'none',
                        viewport: {
                                width: 0,
                                height: 0
                        },
                        showIntro: false
                }

                this.resize = this.resize.bind(this)
                this.bind = this.bind.bind(this)
                this.removeBind = this.removeBind.bind(this)
                this.hideIntro = this.hideIntro.bind(this)
                this.showIntro = this.showIntro.bind(this)
                this.runIntroAnimation = this.runIntroAnimation.bind(this)

        }


        setMask(maskStyles) {

                const mask = getGlobalMask();
                if (mask) {
                        gsap.set(mask, maskStyles)
                }

        }

        getMask() {
                return getGlobalMask();
        }

        isIntroComplete() {
                return globalIntroShown;
        }

        show() {

                this.setState({
                        wrapperDisplay: 'block'
                })

        }

        hide() {

                this.setState({
                        wrapperDisplay: 'none'
                })

        }


        showIntro(){
                this.setState({
                        showIntro: true
                })
        }

        hideIntro(){

                if (!this.intro) return;

                gsap.to(this.intro, {
                        duration: 0.5,
                        opacity: 0,
                        // marginTop: -100,
                        ease: 'power4.easeIn',
                        onComplete: () => {
                                if (this.intro) {
                                        this.intro.style.display = "none"
                                }
                        }
                })

        }

        runIntroAnimation() {
                // First time visit - show full intro animation
                this.showIntro()

                // Mask covers the screen (should already be covering from initial style)
                this.setMask({
                        top: 0,
                        bottom: 0
                })

                setTimeout(() => {
                        this.hideIntro()
                }, 1250)

                // Set up callback for when page signals it's ready
                setIntroRevealCallback(() => {
                        
                        // Get mask fresh - it should be available now
                        const mask = this.getMask();
                        
                        
                        // Show the content (hidden behind mask)
                        this.show();
                        globalIntroShown = true;

                        // Use double rAF to ensure content is painted
                        window.setTimeout(() => {
                                
                                        // Slide mask DOWN out of viewport to reveal content
                                        if (mask) {
                                                gsap.to(mask, {
                                                        duration: 0.6,
                                                        bottom: '100%',
                                                        ease: 'power4.easeIn',
                                                        onComplete: () => {
                                                                // Reset mask for next navigation
                                                                gsap.set(mask, {
                                                                        top: 0,
                                                                        bottom: '100%'
                                                                });
                                                        }
                                                })
                                        }
                                
                        }, 1750);
                });
        }

        resize() {
                this.setHeight()
        }

        componentWillUnmount() {
                this.removeBind()
        }

        bind() {
                window.addEventListener('resize', this.cb)
        }

        removeBind() {
                window.removeEventListener('resize', this.cb)
        }

        setHeight() {

                const viewport = getViewportSize()

                this.setState({
                        viewport
                })

        }

        componentDidMount() {

                this.cb = throttle(this.resize)

                this.setHeight()
                this.bind()


                // Only run intro animation on first visit
                // Subsequent enter animations are triggered by Transition callbacks in App.js
                if (!globalIntroShown) {
                        this.runIntroAnimation()
                }

        }


        render() {

                const { showIntro } = this.state
                const { children } = this.props

                const wrapperStyle = {
                        display: this.state.wrapperDisplay
                }

                const introStyle = {
                        display: showIntro ? "block" : "none"
                }

                return (

                        <div>

                                <div style={introStyle} className="intro text-center" ref={(intro) => { this.intro = intro; }}>

                                        <div className='hr-container'>
                                                <hr />
                                        </div>

                                        <h2 className="mb0">Rob Phillips</h2>
                                        <p>Web Developer</p>
                                </div>

                                <div style={wrapperStyle} className="wrapper">
                                        {children}
                                </div>

                        </div>

                );
        }
}

export default AnimatedWrapper
